import { memo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Popup } from "../../components/Popup";
import { CvvPrepareGate } from "../../components/CvvPrepareGate";
import { LOLA_ROUTES } from "../../constants";
import { mockCards } from "../../gallery/mockData";
import { ConfirmationPage } from "./ConfirmationPage";

/**
 * Gallery inspectable state: certified confirmation with the funding
 * CVV prepare popup open.
 */
export const CvvPrepareGatePage = memo(() => {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(true);
  const card = mockCards[0];

  return (
    <>
      <ConfirmationPage />
      <Popup
        visible={visible}
        onClose={() => {
          setVisible(false);
          navigate(LOLA_ROUTES.CONFIRMATION);
        }}
      >
        <CvvPrepareGate
          ns="lola"
          last4={card.last4 ?? "1111"}
          brand={card.brand ?? undefined}
          onClose={() => {
            setVisible(false);
            navigate(LOLA_ROUTES.CONFIRMATION);
          }}
          onSubmit={() => {
            navigate(LOLA_ROUTES.TRANSFERRING, { replace: true });
          }}
        />
      </Popup>
    </>
  );
});
